<template>
  <div>
    <div class="clear">
      <self-back v-if="statement_id" :pageHeaderList="[{'name':'我的结算单申请',path:'/myStatementApply'},{'name':'申请结算单盖章', path:`/statementSealDetail/${type}?id=${statement_id}&enable_apply=${enable_apply}&sealType=${sealType}`}]" style="float:left" />
      <div style="display:inline-block;float:right;margin-top:10px">
        <el-button type='primary' size='mini' @click="print_png_DOM">导出<span style="font-size:12px">（图片格式）</span></el-button>
        <el-button type='primary' size='mini' @click="printDOM">导出<span style="font-size:12px">（PDF格式）</span><i v-show="exportFlag" class="el-icon-loading"></i></el-button>
      </div>
    </div>
    <div class="statementToast" v-loading='loading'>
      <div v-if="dataInfo.account&&dataInfo.order">
        <div ref="printStatement2" id="ImageExportDom">
          <img src="@/assets/img/voided.png" v-if="dataInfo.account.is_voided==1&&enable_apply!=1" class="voided" alt="">
          <div class="mainTitle">
            <h3 v-if="type==2">MCN机构服务费结算单盖章申请</h3>
            <h3 v-else>{{dataInfo.account.party_a_name}}结算单盖章申请</h3>
            <div class="bothSides">甲方：{{dataInfo.account.party_a_name}}</div>
            <div class="bothSides">乙方：{{dataInfo.account.name}}</div>
            <div class="bothSides statementsID" style="top:34px;" v-if="sealDetail.info.statements_seal_id">盖章申请序列号：{{sealDetail.info.statements_seal_id}}</div>
            <div class="bothSides statementsID" v-if="dataInfo.account.statements_id">结算单序列号：{{dataInfo.account.statements_id}}</div>
            <div class="bothSides statementsID" style="top:100px" v-if="statement_id">结算单审核状态：{{dataInfo.account.verify_status == 0 ?'已保存':dataInfo.account.verify_status == 1?'商务待审核':dataInfo.account.verify_status == 2?'财务待审核':dataInfo.account.verify_status == 3?'商务驳回':dataInfo.account.verify_status == 4?'财务审核通过':dataInfo.account.verify_status == 5?'财务驳回':''}}</div>
            <div class="bothSides statementsID" style="top:75px" v-if="dataInfo&&dataInfo.account&&dataInfo.account.applicant_time">结算单申请时间：{{dataInfo.account.applicant_time}}</div>
          </div>
          <game-statement :dataInfo="dataInfo" v-if="type==5"></game-statement>
          <cpa-statement :dataInfo="dataInfo" v-if="type==4"></cpa-statement>
          <mcn-statement :dataInfo="dataInfo" v-if="type==2" :statement_id='statement_id'></mcn-statement>
          <pdd-statement :dataInfo="dataInfo" v-if="type==6"></pdd-statement>
          <div class="bothSidesBox clear">
            <div class="aParty">
              <div class="title">甲方银行账号信息如下：</div>
              <div class="infoItem">
                <label>名称：</label>
                <div class="inputDiv">{{dataInfo.account.party_a_name}}</div>
              </div>
              <div class="infoItem">
                <label>税号：</label>
                <div class="inputDiv">{{dataInfo.account.party_a_ein}}</div>
              </div>
              <div class="infoItem">
                <label style="vertical-align: top;">地址/电话：</label>
                <div class="inputDiv">{{dataInfo.account.party_a_address}}</div>
              </div>
              <div class="infoItem">
                <label style="vertical-align: top;">银行/账号：</label>
                <div class="inputDiv">{{dataInfo.account.party_a_account}}</div>
              </div>
              <div class="infoItem">
                <label style="width:100%">甲方：{{dataInfo.account.party_a_name}}</label>
              </div>
              <div class="infoItem">
                <label>签字盖章：</label>
              </div>
              <div class="infoItem">
                <label>联系人：</label>
                <div class="inputDiv">{{dataInfo.account.party_a_contact}}</div>
              </div>
              <div class="infoItem">
                <label>联系电话：</label>
                <div class="inputDiv">{{dataInfo.account.party_a_phone}}</div>
              </div>
              <div class="infoItem">
                <label>日期：</label>
                <div class="inputDiv">{{dataInfo.account.party_a_add_date}}</div>
              </div>
            </div>
            <div class="aParty">
              <div class="title">乙方银行账号信息如下：</div>
              <div class="infoItem">
                <label>账号名称：</label>
                <div class="inputDiv">{{dataInfo.account.name}}</div>
              </div>
              <div class="infoItem">
                <label>开户银行：</label>
                <div class="inputDiv">{{dataInfo.account.bank}}</div>
              </div>
              <div class="infoItem">
                <label>账户：</label>
                <div class="inputDiv">{{dataInfo.account.account}}</div>
              </div>

              <div class="infoItem" style="margin-top:58px">
                <label style="width:100%">乙方：{{dataInfo.account.name}}</label>
              </div>
              <div class="infoItem">
                <label>签字盖章：</label>
              </div>
              <div class="infoItem">
                <label>联系人：</label>
                <div class="inputDiv">{{dataInfo.account.party_b_contact}}</div>
              </div>
              <div class="infoItem">
                <label>联系电话：</label>
                <div class="inputDiv">{{dataInfo.account.party_b_phone}}</div>
              </div>
              <div class="infoItem">
                <label>日期：</label>
                <div class="inputDiv">{{dataInfo.account.add_date}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="verify_opinion" v-if="statement_id&&dataInfo.account&&dataInfo.account.files&&dataInfo.account.files.length>0">
          <label style="vertical-align: top;">附件</label>
          <div v-if="uploadFile.length!=0" style="display:inline-block">
            <div v-for="(item,index) in uploadFile" :key="index">
              <div class="enclosure" @click="lookFile(item)">
                <i class="el-icon-search"></i>
                <span>{{item&&item.split('/')&&item.split('/')[item.split('/').length-1]?item.split('/')[item.split('/').length-1]:'附件'}}</span>
              </div>
              <div class="enclosure" @click="downLoadFiles(item)">
                <i class="el-icon-download"></i>
                <span>下载附件</span>
              </div>
            </div>
          </div>
        </div>
        <div class="verify_opinion">
          <div class="item" style="line-height: 20px;">
            <label>经手人备注：</label>
            <span style="color:#5E5F6B;font-size:14px;">{{ dataInfo.account.handler_remark || '-' }}</span>
          </div>
        </div>
        <div class="verify_opinion">
          <div class="item" v-if="dataInfo.account.verify_status&&dataInfo.account.verify_status!=1">
            <div style="margin:5px 0">
              <label>商务审核人：</label>
              <span style="color:#5E5F6B;font-size:14px;">{{dataInfo.account.verify_user}}</span>
            </div>
            <div style="margin:5px 0">
              <label>商务审核时间：</label>
              <span style="color:#5E5F6B;font-size:14px;">{{dataInfo.account.verify_time}}</span>
            </div>
            <div style="margin:5px 0">
              <label>商务审核备注：</label>
              <span style="font-size:14px;" :style="dataInfo.account.verify_status == 3 ? 'color:#d51313':'color:#5E5F6B'">{{dataInfo.account.verify_opinion}}</span>
            </div>
          </div>
        </div>
        <div class="verify_opinion" v-if="dataInfo.account.verify_status==4||dataInfo.account.verify_status==5">
          <div style="margin:5px 0">
            <label>财务审核人：</label>
            <span style="color:#5E5F6B;font-size:14px;">{{dataInfo.account.confirm_verify_user}}</span>
          </div>
          <div style="margin:5px 0">
            <label>财务审核时间：</label>
            <span style="color:#5E5F6B;font-size:14px;">{{dataInfo.account.confirm_verify_time}}</span>
          </div>
          <div style="margin:5px 0">
            <label>财务审核备注：</label>
            <span style="font-size:14px;" :style="dataInfo.account.verify_status == 5 ? 'color:#d51313':'color:#5E5F6B;'">{{dataInfo.account.confirm_verify_opinion}}</span>
          </div>
        </div>

        <el-divider content-position="left" class="divider">结算单盖章</el-divider>
        <div v-if="sealType" class="verify_opinion form-item">
          <label style="margin-left:4px;margin-right:0;">类型：</label>
          <span v-if="sealType == 1" style="font-size:14px;color:#5E5F6B;">含本公司结算单盖章</span>
          <span v-else-if="sealType == 2" style="font-size:14px;color:#5E5F6B;">仅客户公司结算单盖章</span>
        </div>
        <div class="verify_opinion form-item" v-if="action == 1 || action == 3">
          <label style="font-size:14px;margin-left:-4px;margin-right:6px;">
            <em class="stars" :style="{opacity: sealType == 2 ? 1 : 0}">*</em>附件：
          </label>
          <div v-if="uploadFileSeal.length">
            <div class="file-item" v-for="(item,index) in uploadFileSeal" :key="index">
              <div class="enclosure m-0" @click="lookFile(item)">
                <i class="el-icon-search"></i>
                <span>{{item&&item.split('/')&&item.split('/')[item.split('/').length-1]?item.split('/')[item.split('/').length-1]:'附件'}}</span>
              </div>
              <div class="enclosure m-0 ml-10" @click="downLoadFiles(item)">
                <i class="el-icon-download"></i>
                <span>下载附件</span>
              </div>
            </div>
          </div>
          <span v-else style="font-size:14px;color:#5E5F6B;"> - </span>
        </div>
        <div v-if="action == 2" class="verify_opinion uploadFileSeal-wrap">
          <em v-if="sealType == 2" class="stars">*</em>
          <addFile @file='(val)=>{uploadFileSeal=val}' :fileOtherList='fileListSeal' :uploadOtherFile='uploadFileSeal' />
        </div>
        <div class="verify_opinion form-item">
          <label style="margin-left:4px;margin-right:0;">盖章份数：</label>
          <span v-if="action==1 || action==3" style="font-size:14px;color:#5E5F6B;">{{ copies }}</span>
          <el-input-number v-else size="mini" v-model="copies" :min="1" />
        </div>
        <div class="verify_opinion form-item">
          <label style="margin-left:4px;margin-right:0;">申请人备注：</label>
          <span v-if="action==1 || action==3" style="font-size:14px;color:#5E5F6B;">{{ sealDetail.info.handler_remark || '-' }}</span>
          <el-input v-else class="textarea" type="textarea" placeholder="请输入" v-model="sealDetail.info.handler_remark" />
        </div>
        <template v-if="action == 1 || action == 3 || sealDetail.info.statements_seal_id">
          <div class="verify_opinion form-item">
            <label style="margin-left:4px;margin-right:0;">申请人：</label>
            <span style="font-size:14px;color:#5E5F6B;">{{ sealDetail.info.applicant }}</span>
          </div>
          <div class="verify_opinion form-item">
            <label style="margin-left:4px;margin-right:0;">申请时间：</label>
            <span style="font-size:14px;color:#5E5F6B;">{{ sealDetail.info.applicant_time }}</span>
          </div>
          <div class="verify_opinion form-item">
            <label style="margin-left:4px;margin-right:0;">订单金额：</label>
            <span style="font-size:14px;color:#5E5F6B;">{{ sealDetail.info.order_amount }}</span>
          </div>
          <div class="verify_opinion form-item">
            <label style="margin-left:4px;margin-right:0;">审核状态：</label>
            <span style="font-size:14px;color:#5E5F6B;">{{ sealDetail.info.verify_note }}</span>
          </div>
          <template v-if="sealDetail.verify_list && sealDetail.verify_list.length">
            <el-divider content-position="left" class="divider">盖章审核信息</el-divider>
            <div v-for="(item, idx) in sealDetail.verify_list" :key="idx">
              <div class="verify_opinion form-item">
                <label style="margin-left:4px;margin-right:0;">{{ item.role_name }}：</label>
                <span style="font-size:14px;color:#5E5F6B;">{{ item.auditor_name }}</span>
              </div>
              <div class="verify_opinion form-item" style="margin-top:0;">
                <label style="margin-left:4px;margin-right:0;">审核状态：</label>
                <span style="font-size:14px;color:#5E5F6B;">{{ item.status == 1 ? '通过' : '不通过' }}</span>
              </div>
              <div class="verify_opinion form-item" style="margin-top:0;">
                <label style="margin-left:4px;margin-right:0;">审核说明：</label>
                <span style="font-size:14px;color:#5E5F6B;">{{ item.remark || '-' }}</span>
              </div>
              <div class="verify_opinion form-item" style="margin-top:0;">
                <label style="margin-left:4px;margin-right:0;">审核时间：</label>
                <span style="font-size:14px;color:#5E5F6B;">{{ item.create_time || '-' }}</span>
              </div>
            </div>
          </template>
        </template>

        <!-- S 提交申请 -->
        <div v-if="action==2" slot="footer" style="text-align: center;margin-top:40px" class="no-print">
          <el-button type="primary" size='small' @click="editStatement()">{{ sealDetail.info.statements_seal_id ? '重新提交盖章申请' : '提交盖章申请' }}</el-button>
        </div>
        <!-- E 提交申请 -->

        <!-- S 审核 -->
        <template v-if="action==3 && sealDetail.info.enable_verify == 1">
          <el-divider content-position="left" class="divider">结算单盖章审核</el-divider>
          <div class="verify_opinion form-item">
            <label style="margin-left:4px;margin-right:0;">审核备注：</label>
            <el-input class="textarea" type="textarea" placeholder="请输入审核备注" v-model="remark" />
          </div>
          <div slot="footer" style="text-align: center;margin-top:40px" class="no-print">
            <el-button type="primary" size='small' @click="onClickVerify(1)">审核通过</el-button>
            <el-button type="primary" size='small' @click="onClickVerify(2)" style="background:#d51313;border-color:#d51313">审核不通过</el-button>
          </div>
        </template>
        <!-- E 审核 -->
      </div>
    </div>
    <!-- 导出文件 -->
    <export-tem :dataInfo='dataInfo' :type='type' v-if="exportFlag" @exportSuccess='exportFlag=false;'></export-tem>
    <!-- 查看文件  -->
    <!-- <look-file v-if="lookFlag" :fileUrl = 'file_url' @close="()=>{lookFlag=false}"></look-file> -->
  </div>
</template>
<script>
import addFile from '@/components/assembly/addFile'
// import lookFile from '@/components/assembly/lookFile'
import gameStatement from '../examine/gameStatement.vue';
import cpaStatement from '../examine/cpaStatement.vue';
import mcnStatement from './mcnStatementDetail.vue'
import pddStatement from '../examine/pddStatement.vue'
import exportTem from './exportTem.vue'
import { getCookie,delAllCookie } from '@/assets/js/cookie.js'

export default {
  components: { gameStatement, cpaStatement, mcnStatement, pddStatement, exportTem, addFile },
  data (){
    return {
      loading: false,
      type: '',
      dataInfo: {},
      add_date: '',
      party_a_add_date: '',
      discountFlag: 0,
      fileList: [],
      uploadFile: [],
      // lookFlag:false,
      file_url: '',
      statement_id: '',
      exportFlag: false,
      enable_apply: 0,

      sealType: '',
      uploadFileSeal: [],
      fileListSeal: [],
      copies: 1,

      action: 1, // 1盖章详情 2申请盖章 3盖章审核
      statements_seal_id: '',
      sealDetail: {
        info: {
          handler_remark: '',
        },
        verify_list: [],
      },

      remark: '',
    }
  },
  computed: {
    isAllowExport() { // 允许被导出结算单明细的类型
      return [4, 5, 6].includes(Number(this.type))
    },
  },
  created () {
    this.enable_apply = this.$route.query.enable_apply == 1 ? 1 : 0
    this.discountFlag = this.$route.query.discountFlag == 1 ? 1 : 0
    this.action = this.$route.query.action || 1
    this.type = this.$route.params.type;
    this.statement_id = this.$route.query.id;
    this.statements_seal_id = this.$route.query.seal_id || ''
    this.sealType = this.$route.query.sealType;

    if (this.statement_id) {
      if (this.enable_apply == 1) {
        this.statements_reApply()
      } else {
        this.statementsDetail()
      }
    } else {
      var date = new Date();
      this.party_a_add_date = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
      this.add_date = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
      this.dataInfo = localStorage.getItem('statementsAddInfo' + this.$route.query.localName) ? JSON.parse(localStorage.getItem('statementsAddInfo' + this.$route.query.localName)) : {};
    }

    if (this.statements_seal_id) {
      this.handleGetSealDetail()
    }
  },
  methods: {
    downLoadFiles (data) {//下载
      var url = data.replace("http://", window.location.protocol + '//');
      var doc_name = (url.split('/'))[url.split('/').length - 1]
      this.ajax(url, (xhr) => {
        this.downloadFile(xhr.response, doc_name)
      }, {
        responseType: 'blob'
      })
    },
    ajax (url, callback, options) {
      window.URL = window.URL || window.webkitURL
      var xhr = new XMLHttpRequest()
      xhr.open('get', url, true)
      if (options.responseType) {
        xhr.responseType = options.responseType
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          callback(xhr)
        }
      }
      xhr.send()
    },
    downloadFile (content, filename) {
      var a = document.createElement('a')
      var blob = new Blob([content])
      var url = window.URL.createObjectURL(blob)
      a.href = url
      a.download = filename
      a.click()
      window.URL.revokeObjectURL(url)
    },
    lookFile (data) {//查看文件
      this.file_url = data;
      // this.lookFlag = true
      let routeData = this.$router.resolve({
        path: '/lookFile?url=' + this.file_url,
      })
      this.$winopen(routeData.href)
    },
    print_png_DOM () {
      this.$nextTick(() => {
        this.getPdf({
          title: this.type == 2 ? 'MCN机构服务费结算单' : this.dataInfo.account.party_a_name + '结算单', noScrollBar: false, invoice: true, cb: () => {}
        })
      })
    },
    printDOM () {
      this.$loading(this.$loadingConfig);
      this.exportFlag = true;
    },
    statements_reApply () {//作废重新申请详情
      this.loading = true;
      this.$axios.post(this.URL.BASEURL + this.URL.statements_reApply, {
        id: this.statement_id
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.dataInfo = res.rst;
          this.discountFlag = this.dataInfo.account.is_discount;
          var date = new Date();
          this.party_a_add_date = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
          this.add_date = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();

          this.uploadFile = this.dataInfo.account.files ? this.dataInfo.account.files : []
          this.fileList = [];
          if (this.dataInfo.account.files) {
            this.dataInfo.account.files.forEach((item, index) => {
              this.fileList.push({ name: item && item.split('/') && item.split('/')[item.split('/').length - 1] ? item.split('/')[item.split('/').length - 1] : '附件', url: item })
            });
          }
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    statementsDetail () {
      this.loading = true;
      this.$axios.get(this.URL.BASEURL + this.URL.statementsDetail, {
        params: {
          id: this.statement_id
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.dataInfo = res.rst;
          this.discountFlag = this.dataInfo.account.is_discount;
          this.party_a_add_date = this.dataInfo.account.party_a_add_date;
          this.add_date = this.dataInfo.account.add_date;
          this.uploadFile = this.dataInfo.account.files ? this.dataInfo.account.files : []
          this.fileList = [];
          if (this.dataInfo.account.files) {
            this.dataInfo.account.files.forEach((item, index) => {
              this.fileList.push({ name: item && item.split('/') && item.split('/')[item.split('/').length - 1] ? item.split('/')[item.split('/').length - 1] : '附件', url: item })
            });
          }
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    editStatement () {//提交
      if (this.sealType == 2 && (!this.uploadFileSeal || !this.uploadFileSeal.length)) {
        return this.$message.warning('请添加申请盖章附件')
      }
      if (!this.copies) {
        return this.$message.warning('请输入盖章份数')
      }
      this.loading = true;
      const url = `${this.URL.BASEURL}${this.URL.statementsSeal_apply}`
      const params = {
        statements_id: this.statement_id,
        type: this.sealType,
        attachments: this.uploadFileSeal,
        copies: this.copies,
        handler_remark: this.sealDetail.info.handler_remark,
      }
      this.$axios.post(url, params).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.$message.success('提交成功')
          setTimeout(() => {
            this.$router.replace({ path: '/myStatementSealApply' })
          }, 1000);
        } else {
          this.$message.warning(res.err || '提交失败')
        }
      }).catch(() => {
        this.loading = false
      })
    },
    onClickVerify (verify_status) {
      if (verify_status == 2 && !this.remark) {
        return this.$message.warning('请输入审核备注')
      }
      this.$confirm('确认提交当前审核结果吗？').then(() => {
        this.loading = true;
        const url = `${this.URL.BASEURL}${this.URL.statementsSeal_verify}`
        const params = {
          statements_seal_id: this.statements_seal_id,
          verify_status: verify_status,
          remark: this.remark,
        }
        this.$axios.post(url, params).then((res) => {
          var res = res.data;
          this.loading = false;
          if (res && res.errno == 0) {
            this.$message.success('提交成功')
            setTimeout(() => {
              this.$router.replace({ path: '/statementSealExamine' })
            }, 1000);
          } else {
            this.$message.warning(res.err || '提交失败')
          }
        }).catch(() => {
          this.loading = false
        })
      }).catch(() => {})
    },

    onClickExport() {
      if (!this.isAllowExport) return this.$message.warning('当前结算单类型暂不可导出')
      if(!this.statement_id) return this.$message.warning('结算单需要先生成序列号后才可以导出')
      this.loading = true;
      this.$axios.get(this.URL.BASEURL + this.URL.statementsExport, {
        params: {
          id: this.statement_id
        },
      }).then((res) => {
        this.loading = false
        if (res.data.errno == 0) {
          window.open(res.data.rst, "_blank")
        } else {
          this.$message.warning(res.data.err)
        }
      }).catch((err) => {
        this.loading = false
      })
    },

    handleGetSealDetail() {
      this.loading = true;
      this.$axios.get(this.URL.BASEURL + this.URL.statementsSeal_details, {
        params: {
          statements_seal_id: this.statements_seal_id
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.sealDetail = {...res.rst}

          this.sealType = this.sealDetail.info.type
          this.copies = this.sealDetail.info.copies
          this.uploadFileSeal = this.sealDetail.info.attachments ? this.sealDetail.info.attachments : []
          this.fileListSeal = [];
          if (this.uploadFileSeal) {
            this.uploadFileSeal.forEach((item, index) => {
              this.fileListSeal.push({ name: item && item.split('/') && item.split('/')[item.split('/').length - 1] ? item.split('/')[item.split('/').length - 1] : '附件', url: item })
            });
          }

          if (this.sealDetail.info.enable_edit_apply == 1) { // 是否可编辑标识
            this.action = 2
          }
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
  }
}
</script>
<style lang="scss" scoped>
@import "./statementDetail.scss";
.btns-wrap {
  display: flex;
  .export-wrap {
    margin-left: 20px;
    .tips {
      font-size: 12px;
      color: #606266;
      margin-top: 7px;
    }
  }
}
.divider {
  margin-top: 40px;
  margin-bottom: 30px;
}
.form-item {
  margin-top: 10px;
  display: flex;
  align-items: center;
  label {
    margin-left: -4px;
    margin-right: 8px;
    display: inline-block;
    width: 90px;
    color: #202652;
    font-size: 14px;
    line-height: 20px;
    vertical-align: top;
  }
  .file-item {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.uploadFileSeal-wrap {
  margin-top: 15px;
  position: relative;
  .stars {
    position: absolute;
    top: 3px;
    left: 34px;
  }
  /deep/ .upload-demo {
    margin-left: 10px;
  }
}
.stars{
  color: red;
}
.textarea{
        width: 80%;
    }
.m-0 {
  margin:0;
}
.ml-10 {
  margin-left: 10px;
}
</style>
<style lang="scss">
.statementToast {
  .el-form-item__content {
    font-size: 12px !important;
  }
  .el-form-item--mini.el-form-item {
    margin-bottom: 0 !important;
  }
  .table .el-input__inner {
    padding: 0 !important;
    text-align: center !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/newBilling/statementTemplate/templateSeal.vue